{% block sw_cms_element_manufacturer_component %}
    <sw-cms-element-manufacturer-preview></sw-cms-element-manufacturer-preview>
{% endblock %}